import { IconType } from 'react-icons';
import { 
  SiSpringboot, 
  SiKotlin, 
  SiReact, 
  SiTypescript,
  SiJavascript,
  SiNextdotjs,
  SiAmazonaws,
  SiDocker,
  SiJenkins,
  SiApachekafka,
  SiRedis,
  SiMysql,
  SiMariadb,
  SiPostgresql,
  SiGit,
  SiJira,
  SiOracle,
  SiSlack,
  SiDiscord,
  SiNotion,
  SiAmazonrds,
  SiAmazonec2,
  SiAmazons3,
  SiAmazoncloudwatch,
  SiAmazonroute53,
  SiAmazondynamodb
} from 'react-icons/si';
import { FaDatabase, FaJava } from 'react-icons/fa';

export interface Skill {
  name: string;
  icon: IconType;
  category: 'backend' | 'frontend' | 'cloud' | 'database' | 'devops';
}

export const skills: Skill[] = [
  // Backend
  { name: 'Spring Boot', icon: SiSpringboot, category: 'backend' },
  { name: 'Java', icon: FaJava, category: 'backend' },
  { name: 'Kotlin', icon: SiKotlin, category: 'backend' },
  { name: 'JPA', icon: FaDatabase, category: 'backend' },
  { name: 'Spring Security', icon: SiSpringboot, category: 'backend' },
  { name: 'WebFlux', icon: SiSpringboot, category: 'backend' },
  
  // Frontend
  { name: 'JavaScript', icon: SiJavascript, category: 'frontend' },
  { name: 'React', icon: SiReact, category: 'frontend' },
  { name: 'TypeScript', icon: SiTypescript, category: 'frontend' },
  { name: 'Next.js', icon: SiNextdotjs, category: 'frontend' },
  { name: 'JSP', icon: FaJava, category: 'frontend' },
  
  // Cloud
  { name: 'AWS EC2', icon: SiAmazonec2, category: 'cloud' },
  { name: 'AWS RDS', icon: SiAmazonrds, category: 'cloud' },
  { name: 'AWS S3', icon: SiAmazons3, category: 'cloud' },
  { name: 'AWS Load Balancer', icon: SiAmazonaws, category: 'cloud' },
  { name: 'AWS CloudWatch', icon: SiAmazoncloudwatch, category: 'cloud' },
  { name: 'AWS Auto Scaling', icon: SiAmazonaws, category: 'cloud' },
  { name: 'AWS Route53', icon: SiAmazonroute53, category: 'cloud' },
  { name: 'ElastiCache', icon: SiAmazondynamodb, category: 'cloud' },
  { name: 'Beanstalk', icon: SiAmazonaws, category: 'cloud' },
  { name: 'CloudFront', icon: SiAmazonaws, category: 'cloud' },
  
  // Database
  { name: 'MySQL', icon: SiMysql, category: 'database' },
  { name: 'MariaDB', icon: SiMariadb, category: 'database' },
  { name: 'PostgreSQL', icon: SiPostgresql, category: 'database' },
  { name: 'Redis', icon: SiRedis, category: 'database' },
  { name: 'Kafka', icon: SiApachekafka, category: 'database' },
  { name: 'Oracle', icon: SiOracle, category: 'database' },
  
  // DevOps/Tools
  { name: 'Docker', icon: SiDocker, category: 'devops' },
  { name: 'Jenkins', icon: SiJenkins, category: 'devops' },
  { name: 'Git', icon: SiGit, category: 'devops' },
  { name: 'Jira', icon: SiJira, category: 'devops' },
  { name: 'Slack', icon: SiSlack, category: 'devops' },
  { name: 'Discord', icon: SiDiscord, category: 'devops' },
  { name: 'Notion', icon: SiNotion, category: 'devops' },
];
